// 1. include this mixin in your component.
// 2. include <confirm-box
//             :confirmBox="confirmBox"
//             @confirm="confirm"
//             @closeConfirmBox="closeConfirmBox"
//           />
// Inside the <template> tag.
// You can declare @afterConfirm in the component you imported ConfirmBox.
// to do whaterver action you want to do when the user clicks the 'OK' buton.

import ConfirmBox from '@/components/modal/ConfirmBox'

const ConfirmBoxParent = {
  components: {
    ConfirmBox
  },
  props: {
  },
  data () {
    return {
      confirmBox: {
        visible: false,
        msg: null
      }
    }
  },
  methods: {
    openConfirmBox (msg) {
      this.confirmBox = {
        visible: true,
        msg
      }
    },
    confirm () {
      this.closeConfirmBox()
      this.afterConfirm()
    },
    closeConfirmBox () {
      this.confirmBox = {
        visible: false,
        msg: null
      }
    }
  }
}

export default ConfirmBoxParent
